export const MAX_PREVIEW_ROWS = 500;
/** Default how many sheet rows to read in file mode (not a hard create limit). */
export const DEFAULT_PARSE_ROWS = 500;
export const UNMAPPED = '';
export const DEFAULT_SKIP_ROWS = '2';

export const ENTRY_MODE_FILE = 'file';
export const ENTRY_MODE_MANUAL = 'manual';

/** Manual bulk: one currency for the whole batch */
export const PRICE_CURRENCY_POUNDS = 'pounds';
export const PRICE_CURRENCY_USD = 'usd';
export const PRICE_CURRENCY_EURO = 'euro';
export const PRICE_CURRENCY_UAH = 'uah';

export const PRICE_CURRENCY_OPTIONS = [
  { value: PRICE_CURRENCY_POUNDS, label: '£', field: 'priceInPounds', rateKey: 'poundRate' },
  { value: PRICE_CURRENCY_USD, label: '$', field: 'priceInUSD', rateKey: 'dollarRate' },
  { value: PRICE_CURRENCY_EURO, label: '€', field: 'priceInEuro', rateKey: 'euroRate' },
  { value: PRICE_CURRENCY_UAH, label: 'грн', field: 'price', rateKey: null }
];

export const getPriceCurrencyOption = (value) =>
  PRICE_CURRENCY_OPTIONS.find(o => o.value === value) || PRICE_CURRENCY_OPTIONS[0];

/** Дефолтні колонки: G=назва, F=артикул, J=штрихкод, P=ціна £, Q=кількість */
export const DEFAULT_COL = {
  name: 6,
  article: 5,
  barcode: 9,
  price: 15,
  quantity: 16
};
